export const promiseResolve = (value?) => {
    return Promise.resolve(value);
}